/* Etiquetas multiidoma en castellano. */
export default {
  "dateRangePicker.dateFrom.label": "Desde",
  "dateRangePicker.dateTo.label": "Hasta",
};
